import { render, staticRenderFns } from "./GenericTableLocations.vue?vue&type=template&id=28b51fe6&scoped=true"
import script from "./GenericTableLocations.vue?vue&type=script&lang=ts"
export * from "./GenericTableLocations.vue?vue&type=script&lang=ts"
import style0 from "./GenericTableLocations.vue?vue&type=style&index=0&id=28b51fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b51fe6",
  null
  
)

export default component.exports